var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchSector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 14.7C19.0704 19.33 14.6304 22.69 9.58042 21.87C5.79042 21.26 2.74042 18.21 2.12042 14.42C1.31042 9.39001 4.65042 4.95001 9.26042 4.01001",
    fill: "#5679EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 14.7C19.0704 19.33 14.6304 22.69 9.58042 21.87C5.79042 21.26 2.74042 18.21 2.12042 14.42C1.31042 9.39001 4.65042 4.95001 9.26042 4.01001",
    stroke: "#5679EC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7535 14C22.3547 14 23.8505 12.6149 22.5209 8.07197C21.6206 5.01101 18.989 2.3794 15.928 1.47912C11.3851 0.149469 10 1.64533 10 5.24646V9.23542C10 12.6149 11.3851 14 14.1552 14H18.7535Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.32 12.0002C20.92 12.0002 22 11.0002 21.04 7.72018C20.39 5.51018 18.49 3.61018 16.28 2.96018C13 2.00018 12 3.08018 12 5.68018V8.56018C12 11.0002 13 12.0002 15 12.0002H18.32Z",
    stroke: "#3C55A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSector);
export default __webpack_public_path__ + "static/media/search-sector.7132cdff.svg";
export { ForwardRef as ReactComponent };